<template>
    <div class="mt-5">
        <div class="hidden md:grid grid-cols-7 gap-2 p-2 font-medium border-b bg-gray-100">
            <div>
                Loại phí
            </div>
            <div>
                Tên phí
            </div>
            <div>
                Số luợng
            </div>
            <div>
                Giá
            </div>
            <div>
                {{ $t('labels.currency') }}
            </div>
            <div>
                Thuế (%)
            </div>
            <div>
                Thành tiền
            </div>
        </div>

        <template
            v-for="(price, index) in prices"
            :key="index">
            <div class="hidden md:grid grid-cols-7 gap-2 p-2 border-b items-center">
                <div>
                    <template v-if="readonly">
                        <span>
                            {{ price.chargeTypeNane }}
                        </span>
                    </template>
                    <hts-form-input
                        v-else
                        v-model="price.chargeTypeNane"
                        label="" />
                </div>
                <div>
                    <template v-if="readonly">
                        <span>
                            {{ price.priceName }}
                        </span>
                    </template>
                    <hts-form-input
                        v-else
                        v-model="price.priceName"
                        label="" />
                </div>
                <div>
                    <template v-if="readonly">
                        <span>
                            {{ $formatters.formatCurrency(price.quantity) }}
                        </span>
                    </template>
                    <hts-form-input
                        v-else
                        v-model="price.quantity"
                        number-interger
                        type="number"
                        label=""
                        :min="0" />
                </div>
                <div>
                    <template v-if="readonly">
                        <span>
                            {{ $formatters.formatCurrency(price.amount) }}
                        </span>
                    </template>
                    <hts-form-input
                        v-else
                        v-model="price.amount"
                        type="number"
                        label="" />
                </div>
                <div>
                    <p>
                        {{ price.currency }}
                    </p>
                </div>
                <div>
                    <template v-if="readonly">
                        <span>
                            {{ $formatters.formatCurrency(price.tax) }}
                        </span>
                    </template>
                    <hts-form-input
                        v-else
                        v-model="price.tax"
                        label=""
                        :min="0" />
                </div>
                <div>
                    <span>
                        {{ $formatters.formatCurrency(price.total) }}
                    </span>
                </div>
            </div>
        </template>

        <div class="mt-2 pt-2 flex justify-end">
            <div class="grid grid-cols-3 gap-y-2 w-full max-w-md text-right">
                <div class="font-semibold text-left">
                    Tổng tiền
                </div>
                <div class="font-semibold">
                    VND
                </div>
                <div class="font-semibold">
                    {{ $formatters.formatCurrency(cTotalAmount, 10) }}
                </div>

                <div class="font-semibold text-left">
                    Thuế
                </div>
                <div class="font-semibold">
                    VND
                </div>
                <div class="font-semibold">
                    {{ $formatters.formatCurrency(cTotalTax, 10) }}
                </div>

                <div class="font-semibold text-left">
                    Tổng tiền bao gồm thuế
                </div>
                <div class="font-semibold">
                    VND
                </div>
                <div class="font-semibold">
                    {{ $formatters.formatCurrency(cGrandTotal, 10) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: Array as PropType<any[]>,
    required: true
  },
  totalAmount: {
    type: Number,
    required: true
  },
  totalTax: {
    type: Number,
    required: true
  },
  grandTotal: {
    type: Number,
    required: true
  },
  readonly: Boolean
})
const emits = defineEmits(['update:modelValue', 'update:totalAmount', 'update:totalTax', 'update:grandTotal'])

const { readonly, modelValue, totalAmount, totalTax, grandTotal } = toRefs(props)
const prices = computed({
  get () {
    return modelValue.value
  },
  set (val) {
    emits('update:modelValue', val)
  }
})
const cTotalAmount = computed({
  get () {
    return totalAmount.value
  },
  set (val) {
    emits('update:totalAmount', val)
  }
})
const cTotalTax = computed({
  get () {
    return totalTax.value
  },
  set (val) {
    emits('update:totalTax', val)
  }
})
const cGrandTotal = computed({
  get () {
    return grandTotal.value
  },
  set (val) {
    emits('update:grandTotal', val)
  }
})

onMounted(() => {
  pricing()
})

watch(
  () => prices.value,
  () => {
    pricing()
  },
  { deep: true }
)

const pricing = () => {
  let tmp = 0
  let tmpTax = 0
  cTotalAmount.value = 0
  cTotalTax.value = 0
  prices.value.forEach((p: any) => {
    const { amount, quantity } = p
    p.totalAmount = 0
    if (isNaN(amount) || isNaN(quantity)) {
      return
    }
    let tmpTotal = amount * quantity
    tmpTotal = parseFloat(tmpTotal.toPrecision(2))
    const taxRate = Number(p.tax) || 0
    p.total = tmpTotal
    p.totalTax = parseFloat(((taxRate / 100) * tmpTotal).toPrecision(2))
    tmp += tmpTotal
    tmpTax += p.totalTax
  })
  nextTick(() => {
    cTotalAmount.value = tmp
    cTotalTax.value = tmpTax
    cGrandTotal.value = cTotalAmount.value + cTotalTax.value
  })
}
</script>
